<template>
    <div class="box" >
        <div>
            <el-select v-model="selectCK" placeholder=" " size="mini" @change="wmsGetPlaceWithWeight">
                <el-option v-for="item in ckList" :key="item" :label="item" :value="item">
                </el-option>
            </el-select>
        </div>
        <div id="map" class="map">
            <locationMapCard v-for="item in placeList" :key="item.id" :locationMapCard="item"></locationMapCard>
        </div>
    </div>
</template>
<script>
import locationMapCard from '@/components/wms/locationMapCard.vue'
export default {
    name: 'locationMap',
    mixins: [],
    components:{
        locationMapCard,
    },
    watch: { 

    },
    data() {
        return {
            selectCK:'', // 选择的仓库值
            ckList:[], // 仓库列表
            placeList:[], // 库区列表
        }
    },
    mounted() {
        
    },
    created() {
        // 获取当前用户的仓库
        this.$api.wmsGetCkListByLogIn().then(res => { 
            this.ckList = res
            this.selectCK = res[0]
            // 查询库区
            this.wmsGetPlaceWithWeight()
        })
    },
    methods: {
        wmsGetPlaceWithWeight(){
            this.$api.wmsGetPlaceWithWeight(this.selectCK).then(res => { 
                this.placeList = res
            })
        },
    },
    beforeDestroy() {
        
   
    }
}
</script>
<style lang="less" scoped>
.box{
    background-color: #ffffff;
    padding: 10px;
}
.map{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    width: 100%; 
    gap: 12px;
    box-sizing: border-box;
    padding: 0 16px;
}
</style>